import { render } from "./Admin.Tests.Modify.vue?vue&type=template&id=fdfa2468"
import script from "./Admin.Tests.Modify.vue?vue&type=script&lang=js"
export * from "./Admin.Tests.Modify.vue?vue&type=script&lang=js"

import "./Admin.Tests.Modify.vue?vue&type=style&index=0&id=fdfa2468&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__